// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Rubik', sans-serif;
}

.recipe-page {
  padding: 20px;
  text-align: center;
  min-height: 100vh;
}

.recipe-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.recipe-search {
  width: 90%;
  max-width: 400px;
  padding: 10px;
  font-size: 1rem;
  border-radius: 20px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  text-align: center;
  outline: none;
  margin-bottom: 20px;
}

.recipe-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  justify-items: center;
  margin-top: 20px;
  padding: 0 1rem;
}

.recipe-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  justify-items: center;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .recipe-container {
    grid-template-columns: 1fr; 
  }
}

.recipe-box {
  background-color: #A5D6A7;
  border-radius: 15px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 250px;
  height: 80px;
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  cursor: pointer;
  transition: transform 0.2s;
}

.recipe-box:hover {
  transform: scale(1.05);
}

.recipe-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.recipe-popup {
  background: #F0F8E7;
  padding: 25px;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.recipe-sections {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  flex-direction: row;
}

.recipe-section {
  background-color: #A5D6A7;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  width: 50%;
  max-height: 150px;
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease-in-out;
}

.recipe-section:hover {
  overflow-y: auto;
}

.recipe-section::-webkit-scrollbar {
  width: 6px;
}

.recipe-section::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  visibility: hidden;
}

.recipe-section:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}

@media (max-width: 768px) {
  .recipe-popup {
    width: 95%;
    max-width: 400px;
    padding: 20px;
  }

  .recipe-sections {
    flex-direction: column;
  }

  .recipe-section {
    width: 80%;
    max-height: 120px; 
  }
}

.error-message {
  color: #d32f2f;
  background-color: #ffebee;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
}

.no-recipes {
  text-align: center;
  width: 100%;
  grid-column: 1 / -1;
  font-size: 18px;
  color: #666;
  margin-top: 20px;
}

.recipe-image-container {
  margin: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 60vh;
}

.recipe-image {
  max-width: 100%;
  max-height: 55vh; 
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  margin: 0 auto;
}

.recipe-image-placeholder {
  width: 100%;
  max-width: 300px;
  height: 180px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #757575;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .recipe-popup {
    padding: 15px;
    max-height: 85vh; 
  }

  .recipe-image-container {
    max-height: 50vh; 
    margin: 10px 0;
  }

  .recipe-image {
    max-height: 45vh; 
  }

  .recipe-image-placeholder {
    height: 150px;
    max-width: 250px;
  }
}

@media (max-width: 375px) {
  .recipe-image-container {
    max-height: 40vh;
  }
  
  .recipe-image {
    max-height: 38vh;
  }
  
  .recipe-popup {
    max-height: 80vh;
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/ClientRecipesPage.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":["body {\n  font-family: 'Rubik', sans-serif;\n}\n\n.recipe-page {\n  padding: 20px;\n  text-align: center;\n  min-height: 100vh;\n}\n\n.recipe-title {\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.recipe-search {\n  width: 90%;\n  max-width: 400px;\n  padding: 10px;\n  font-size: 1rem;\n  border-radius: 20px;\n  border: 1px solid #ccc;\n  background-color: #f8f8f8;\n  text-align: center;\n  outline: none;\n  margin-bottom: 20px;\n}\n\n.recipe-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2rem;\n  justify-items: center;\n  margin-top: 20px;\n  padding: 0 1rem;\n}\n\n.recipe-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  justify-items: center;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n  .recipe-container {\n    grid-template-columns: 1fr; \n  }\n}\n\n.recipe-box {\n  background-color: #A5D6A7;\n  border-radius: 15px;\n  padding: 15px;\n  text-align: center;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 250px;\n  height: 80px;\n  display: flex; \n  flex-direction: column; \n  justify-content: center; \n  align-items: center; \n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.recipe-box:hover {\n  transform: scale(1.05);\n}\n\n.recipe-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.recipe-popup {\n  background: #F0F8E7;\n  padding: 25px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n  position: relative;\n  text-align: center;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.recipe-sections {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n  flex-direction: row;\n}\n\n.recipe-section {\n  background-color: #A5D6A7;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  width: 50%;\n  max-height: 150px;\n  overflow: hidden;\n  position: relative;\n  transition: max-height 0.3s ease-in-out;\n}\n\n.recipe-section:hover {\n  overflow-y: auto;\n}\n\n.recipe-section::-webkit-scrollbar {\n  width: 6px;\n}\n\n.recipe-section::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  visibility: hidden;\n}\n\n.recipe-section:hover::-webkit-scrollbar-thumb {\n  visibility: visible;\n}\n\n@media (max-width: 768px) {\n  .recipe-popup {\n    width: 95%;\n    max-width: 400px;\n    padding: 20px;\n  }\n\n  .recipe-sections {\n    flex-direction: column;\n  }\n\n  .recipe-section {\n    width: 80%;\n    max-height: 120px; \n  }\n}\n\n.error-message {\n  color: #d32f2f;\n  background-color: #ffebee;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.no-recipes {\n  text-align: center;\n  width: 100%;\n  grid-column: 1 / -1;\n  font-size: 18px;\n  color: #666;\n  margin-top: 20px;\n}\n\n.recipe-image-container {\n  margin: 15px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-height: 60vh;\n}\n\n.recipe-image {\n  max-width: 100%;\n  max-height: 55vh; \n  width: auto;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  object-fit: contain;\n  margin: 0 auto;\n}\n\n.recipe-image-placeholder {\n  width: 100%;\n  max-width: 300px;\n  height: 180px;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #757575;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .recipe-popup {\n    padding: 15px;\n    max-height: 85vh; \n  }\n\n  .recipe-image-container {\n    max-height: 50vh; \n    margin: 10px 0;\n  }\n\n  .recipe-image {\n    max-height: 45vh; \n  }\n\n  .recipe-image-placeholder {\n    height: 150px;\n    max-width: 250px;\n  }\n}\n\n@media (max-width: 375px) {\n  .recipe-image-container {\n    max-height: 40vh;\n  }\n  \n  .recipe-image {\n    max-height: 38vh;\n  }\n  \n  .recipe-popup {\n    max-height: 80vh;\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
